import baseAPI from '@/api/baseAPI'

class AdminsAPI extends baseAPI {
    get entity() {
        return {
            route: `/admins`,
            name: 'المدير'
        }
    }

    addAdmin(data){
        return new Promise((resolve, reject) => {
            return this.request.post(`${this.entity.route}/add-admin`, data)
                .then(response => resolve(this.responseWrapper(response)))
                .catch(error => reject(this.errorWrapper(error)))
        })
    }

    assignAdmin(data) {
        return new Promise((resolve, reject) => {
            return this.request.post(`${this.entity.route}/assign-admin`, data)
                .then(response => resolve(this.responseWrapper(response)))
                .catch(error => reject(this.errorWrapper(error)))
        })
    }

    updateRole(data) {
        return new Promise((resolve, reject) => {
            return this.request.post(`${this.entity.route}/update-roles`, data)
                .then(response => resolve(this.responseWrapper(response)))
                .catch(error => reject(this.errorWrapper(error)))
        })
    }


}

export default new AdminsAPI()
